export enum PinComponentStateEnum {
  OLD,
  NEW,
  CONFIRM,
  PAY,
}
